import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function DashboardPedidos() {
  const url =
    "https://app.powerbi.com/view?r=eyJrIjoiMTIwNTU4MzQtMTI5OC00YjgxLWE2ZmEtNmExYmU1MjM0M2FjIiwidCI6IjU0YmI0MTNmLTJlZmUtNDQ3YS1hY2ZiLTQ4YzhkOTJmYzJkYSJ9";

  return (
    <DashboardLayout>
      <iframe
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        style={{
          border: 0,
          width: "100%",
          height: "1025px",
        }}
        src={url}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardPedidos;
